export default __webpack_public_path__ + "partials/icon_watsi_blog_logo.hbs";